import { Component, OnInit, OnDestroy } from '@angular/core';
import { RelayService } from '@app/core/services/relay.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { Relay } from '@app/core/models/relay';

@Component({
  selector: 'app-global-status',
  templateUrl: './global-status.component.html',
  styleUrls: ['./global-status.component.scss']
})
export class GlobalStatusComponent implements OnInit, OnDestroy {
  displayRelays: boolean = false;
  playStatusSound: any;
  globalStatus?: Relay;
  relays!: Relay[];

  _onGetCurrentRelaysSub!: Subscription;
  _onUpdateRelaySub!: Subscription;

  constructor(
    private relayService: RelayService,
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this._onGetCurrentRelaysSub = this.relayService.onGetCurrentRelays$.subscribe((relays: Relay[]) => {
      this.relays = relays;
      this.checkGlobalStatus();
    });

    this._onUpdateRelaySub = this.relayService.onUpdateRelay$.subscribe((relay: Relay) => {
      const foundIndex = this.relays.findIndex(x => x.id === relay.id);
      this.relays[foundIndex] = relay;
      this.checkGlobalStatus();
    });

    this.relayService.getCurrentRelays();
  }

  checkGlobalStatus () {
    let topStation: Relay | undefined;
    this.relays.forEach((relay: Relay) => {
      if (topStation) {
        if (topStation.messageLevel < relay.messageLevel) {
          topStation = relay;
        }
      } else {
        topStation = relay;
      }
    });

    this.globalStatus = topStation;

    if (this.globalStatus && this.globalStatus.messageStateClass === 'warning' && this.globalStatus.warningAlarm) {
      this.playStatusSound = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(new Blob([new Uint8Array(this.globalStatus.warningAlarm.data)])));
    } else if (this.globalStatus && this.globalStatus.messageStateClass.startsWith('danger') && this.globalStatus.dangerAlarm) {
      this.playStatusSound = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(new Blob([new Uint8Array(this.globalStatus.dangerAlarm.data)])));
    } else {
      this.playStatusSound = undefined;
    }
  }

  onDisplayRelays () {
    this.displayRelays = true;
  }

  ngOnDestroy() {
    this._onGetCurrentRelaysSub.unsubscribe();
    this._onUpdateRelaySub.unsubscribe();
  }
}
